<template>
  <component :is="layout"></component>
</template>

<script>
export default {
  name: "app",
  computed: {
    layout() {
      return (this.$route.meta.layout || "app") + "-layout";
    }
  }
};
</script>

<style lang="scss"></style>
